import type { FunctionComponentWithChildren } from '@bonsai-components/utility-types';
import { spacing } from '@moderneinc/design-system-tokens';
import { Box } from '@mui/material';

export const PersistentToastStack: FunctionComponentWithChildren = ({
  children
}) => (
  <Box
    sx={{
      position: 'fixed',
      bottom: spacing.spacing_3,
      right: spacing.spacing_3,
      zIndex: (theme) => theme.zIndex.snackbar,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: `${spacing.spacing_1}px`
    }}
  >
    {children}
  </Box>
);
